import { KeyboardShortcutPill } from "@core/components/_original/KeyboardShortcutPill";
import { type Component, Match, Switch, createMemo } from "solid-js";
import { usePromptContext } from "./PromptContext";
import { useWire } from "@core/wire";
import { MESSAGE_LIMIT } from "../constants";

export const ChatTips: Component = () => {
  const { focused, promptSettings, editor, isConnecting } = usePromptContext();
  const wire = useWire();
  const keybinding = () => (promptSettings.submitKeybinding === "enter" ? ["Shift", "Enter"] : ["Enter"]);
  const empty = createMemo(() => !!editor()?.isEmpty);
  const isMessageLimitReached = createMemo(() => wire.services.threads.messages().length > MESSAGE_LIMIT);
  return (
    <Switch>
      <Match when={isMessageLimitReached()}>
        <div class="hidden sm:block absolute right-12 pointer-events-none sm:text-2xs text-red-500 dark:text-red-400">
          <span>Limit of {MESSAGE_LIMIT} messages per thread reached. Start a new chat to continue</span>
        </div>
      </Match>
      <Match when={isConnecting()}>
        <div class="hidden sm:block absolute right-12 pointer-events-none sm:text-2xs text-gray-500 dark:text-slate-400">
          <span class="animate-pulse">Connecting...</span>
        </div>
      </Match>
      <Match when={focused() && empty()}>
        <div class="hidden sm:block absolute right-12 pointer-events-none sm:text-2xs text-gray-500 dark:text-slate-400">
          <span class="animate-pulse">
            <KeyboardShortcutPill keys={keybinding()} /> for new lines
          </span>
        </div>
      </Match>
      <Match when={!focused() && empty()}>
        <div class="hidden sm:block absolute right-12 pointer-events-none sm:text-2xs text-gray-500 dark:text-slate-400">
          <span class="animate-pulse">
            <KeyboardShortcutPill keys={["Ctrl", "K"]} /> to focus on prompt
          </span>
        </div>
      </Match>
    </Switch>
  );
};
